var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.txt)?_c('div',{staticClass:"item-err-tip"},[_c('div',{staticClass:"item-err-tip-txt"},[_vm._v("Hướng dẫn："+_vm._s(_vm.txt || ''))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }